import styled from "styled-components";
import { Link } from "react-router-dom";
import { primaryColor, primaryColorHover } from "../../../../../config/constants";

// Styles
export const SessionMainDiv = styled.div`
  margin: 0 auto 10px;
  max-width: 860px;
  @media (max-width: 910px) {
    margin: 0 auto 10px;
    width: 85%;
  }
`;
export const SessionDiv = styled.div`
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const SessionText = styled.p`
  width: ${({ width }) => width && width};
  font-size: 14px;
  text-align: center;
  @media (max-width: 910px) {
    width: ${({ width910 }) => width910 && width910};
    font-size: 12px;
  }
`;
export const DetailsDiv = styled.div`
  width: ${({ width }) => width && width};
  display: flex;
  justify-content: center;
`;
export const DetailsLink = styled(Link)`
  width: 35px;
  height: 35px;
  background-color: ${primaryColor};
  border-radius: 5px;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${primaryColorHover};
  }
  @media (max-width: 910px) {
    width: 25px;
    height: 25px;
  }
`;
export const DetailsImg = styled.img`
  width: 70%;
  height: 70%;
`;
